import { AdminProfile, NavPage } from '../types';

interface Props {
  activePage: NavPage;
  adminProfile: AdminProfile | null;
}

const PAGE_TITLES: Record<NavPage, string> = {
  dashboard:    'Dashboard',
  athletes:     'Athletes',
  institutions: 'Institutions',
  huddle:       'The Huddle',
  waitlist:     'Waitlist',
  insights:     'Insights',
  settings:     'Settings',
  pathways:     'Pathways',
  legacy:       'Legacy',
  leadership:   'Leadership',
  reports:      'Reports',
  mentors:      'Mentors',
};

export default function Topbar({ activePage, adminProfile }: Props) {
  const isBthdInternal = !adminProfile?.institutionType || adminProfile.institutionType === 'bthd_internal';
  const userLabel = isBthdInternal
    ? 'BTHD Founder'
    : `${adminProfile?.institutionName ?? adminProfile?.institutionType ?? 'Institution'} · Admin`;

  return (
    <header style={{
      background: 'var(--surface)',
      borderBottom: '1px solid var(--border)',
      padding: '0 24px',
      height: 'var(--topbar-h)',
      display: 'flex', alignItems: 'center', gap: 16,
      position: 'sticky', top: 0, zIndex: 50, flexShrink: 0,
    }}>
      <div>
        <div style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 800, fontSize: 18, letterSpacing: 0.5, color: 'var(--text)', lineHeight: 1 }}>
          {PAGE_TITLES[activePage] || 'Command Center'}
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 1 }}>
          {new Date().toLocaleDateString('en-CA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center' }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '5px 10px', borderRadius: 8,
          background: 'rgba(15,168,109,0.1)', border: '1px solid rgba(15,168,109,0.2)',
        }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#0fa86d', animation: 'pulse 1.4s infinite' }} />
          <span style={{ fontSize: 11, fontWeight: 700, color: '#0fa86d', letterSpacing: 0.5 }}>LIVE</span>
        </div>

        <div style={{
          fontSize: 12, color: 'var(--text-3)', fontWeight: 500,
          padding: '5px 10px', borderRadius: 8, background: 'var(--surface-2)', border: '1px solid var(--border)',
        }}>
          {userLabel}
        </div>
      </div>
    </header>
  );
}
